export default __webpack_public_path__ + "static/media/susie6.f4bec9df.jpg";